import React, { Component } from 'react'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'


export class EditorConvertToHTML extends Component {
  constructor(props) {
    super(props)
    const html = props.html || "<p></p>"; 
    const contentBlock = htmlToDraft(html)
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
      const editorState = EditorState.createWithContent(contentState)
      this.state = {
        editorState,
      }
    }
    this.setDomEditorRef = ref => this.domEditor = ref;
  }

  componentDidMount(){
    // as per method in https://github.com/jpuri/react-draft-wysiwyg/blob/master/src/Editor/index.js
    this.domEditor.focusEditor();
  }

   onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    })
    this.props.update(draftToHtml(convertToRaw(editorState.getCurrentContent())))
  }

  render() {
    const { editorState } = this.state
    return (
      <div>
        <Editor
          ref={this.setDomEditorRef}
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          stripPastedStyles={true}
          toolbar={
            {
              fontFamily: {
                options: [
                  'Arial',
                  'Georgia',
                  'Impact',
                  'Tahoma',
                  'Times New Roman',
                  'Verdana',
                  'Montserrat',
                  'Montserrat light',
                  'Poppins',
                  'Poppins medium'
                ]
              }
            }
          }
        />
      </div>
    )
  }
}
